import { render, staticRenderFns } from "./MyShiftsView.vue?vue&type=template&id=51fe79e0&scoped=true&"
import script from "./MyShiftsView.vue?vue&type=script&lang=js&"
export * from "./MyShiftsView.vue?vue&type=script&lang=js&"
import style0 from "./MyShiftsView.vue?vue&type=style&index=0&id=51fe79e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fe79e0",
  null
  
)

export default component.exports